import React, {useState, useEffect} from 'react'

const CatalogueFilterCheckbox = ({name, filter}) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(filter.indexOf(`${name}`) > -1)
  }, [filter]);

  return (
    <li>
      <label><input type="checkbox"
                    className="checkbox"
                    name={`${name}`}
                    checked={checked}
                    onChange={() => setChecked(!checked)}/>
        <span className="checkbox-custom"/>
        <span className="label">{name}</span>
      </label>
    </li>
  )
};

export default CatalogueFilterCheckbox
